export default {
  history: "billing/history",
};
